// extracted by mini-css-extract-plugin
export default {"content":"FeePreview_content__I8b7c","loader":"FeePreview_loader__AiDq1"};